import { render, staticRenderFns } from "./book-open.vue?vue&type=template&id=cda0dcda&"
import script from "./book-open.vue?vue&type=script&lang=js&"
export * from "./book-open.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports